// import { useEffect } from "react";

// const ShareButtons = () => {
//   useEffect(() => {
//     if (document.getElementById("sharethis-script")) return;

//     const script = document.createElement("script");
//     script.id = "sharethis-script";
//     script.src =
//       "https://platform-api.sharethis.com/js/sharethis.js#property=68b597c65b7a352c0f780c8c&product=inline-share-buttons";
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);

//   return (
//     <div className="sharethis-inline-share-buttons"></div>
//   );
// };

// export default ShareButtons;


import { useEffect } from "react";

const ShareButtons = () => {
  useEffect(() => {
    const loadShareThis = () => {
      if (window.__sharethis__) {
        window.__sharethis__.initialize();
      }
    };

    if (window.__sharethis__) {
      loadShareThis();
      return;
    }

    if (document.getElementById("sharethis-script")) return;

    const script = document.createElement("script");
    script.id = "sharethis-script";
    script.src =
      "https://platform-api.sharethis.com/js/sharethis.js#property=68b597c65b7a352c0f780c8c&product=inline-share-buttons";
    script.async = true;

    script.onload = loadShareThis;

    document.body.appendChild(script);
  }, []);

  return <div className="sharethis-inline-share-buttons" style={{zIndex:"1"}}></div>;
};

export default ShareButtons;
